import {
   ValidationObserver,
   ValidationProvider,
 } from "vee-validate";
import Spinner from 'vue-simple-spinner';

// export var cv_id = window.location.pathname.split('/')[2];

export var mixin_basic = ({
    components: {
      Spinner,
      ValidationProvider,
      ValidationObserver
    },
    props: {
      item: Object,
      index: Number,
      arraylen: Number,
      isLoading: Boolean,
      itemCollapseShow: Number,
    },
    computed : {
        date_year_options() {
            var currentYear = new Date().getFullYear();
            var startYear = 1968;
            var years = []
            while ( startYear <= currentYear ) {
            var newYear = startYear++
            years.push({ text: newYear, value: newYear });
            }
            return years;
        },
        date_month_options() {
            var startMonth = 1;
            var endMonth = 12;
            var months = [];
            while ( startMonth <= endMonth ) {
            var newMonth = startMonth++
            months.push({ text: newMonth, value: newMonth });
            }
            return months;
        },
    },



    // updated: function () {
    //     this.$nextTick(function () {
    //         console.log('---- Updated called ----')
    //         // Code that will run only after the
    //         // entire view has been re-rendered
    //         $(document).ready(function() {
    //             $('.wysiswg').summernote({
    //                 // placeholder: 'Hello bootstrap 4',
    //                 tabsize: 2,
    //                 height: 100,
    //                 'toolbar': [
    //                     ['style', ['bold', 'italic', 'underline',]],
    //                     ['para', ['ul', 'ol', 'paragraph']],
    //                 ],
    //               });
    //         });
    //     })
    // },

});
